import React from 'react'

/**
 * Auto-save status indicator for rich text editor
 * Shows visual feedback for saving/saved/error states
 */
const AutoSaveIndicator = ({ status, lastSavedTime }) => {
  const variants = {
    saving: {
      icon: (
        <svg
          className="animate-spin h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      ),
      text: 'Saving...',
      color: 'text-yellow-500',
    },
    saved: {
      icon: (
        <svg
          className="h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
      ),
      text: 'All changes saved',
      color: 'text-green-500',
    },
    error: {
      icon: (
        <svg
          className="h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      ),
      text: 'Save failed - retrying',
      color: 'text-red-500',
    },
    idle: {
      icon: null,
      text: '',
      color: 'text-gray-400',
    },
  }

  const { icon, text, color } = variants[status] || variants.idle

  if (status === 'idle') return null

  return (
    <div className={`flex items-center gap-2 text-sm ${color} px-4 py-2`}>
      {icon}
      <span>{text}</span>
      {status === 'saved' && lastSavedTime && (
        <span className="text-gray-400 text-xs ml-2">
          {new Date(lastSavedTime).toLocaleTimeString()}
        </span>
      )}
    </div>
  )
}

export default AutoSaveIndicator
